<template>
  <v-dialog scrollable persistent v-model="dialog">
    <v-card width="90vw" style="min-height: 550px;">

      <v-card-text style="overflow: visible;">

        <div style="margin-top:20px; display:flex; gap:20px; flex-wrap:wrap; color:gray">
          <div style="width:220px;">
            <div class="field-label">Acceptance Threshold</div>
            <input
              class="field-input"
              type="number"
              min="0"
              max="100"
              step="1"
              v-model.number="draft.acceptance_rate_threshold"
              @input="clearErrors"
            />
            <span>%</span>
          </div>

          <div style="width:220px;">
            <div class="field-label">Conversion Threshold</div>
            <input
              class="field-input"
              type="number"
              min="0"
              max="100"
              step="1"
              v-model.number="draft.conversion_rate_threshold"
              @input="clearErrors"
            />
            <span>%</span>
          </div>

          <div style="width:220px;">
            <div class="field-label">Bonus Pool</div>
            <span>$</span>
            <input
              class="field-input"
              type="number"
              min="0"
              step="1"
              v-model.number="draft.bonus_pool"
              @input="clearErrors"
            />
          </div>

        </div>

        <div style="margin-top: 30px">
          <v-autocomplete
            v-model="draft.excludedCustomers"
            :items="customers_arr"
            item-title="title"
            item-value="value"
            multiple
            clearable
            variant="outlined"
            density="compact"
            label="Excluded Customers"
            hide-selected
          />
        </div>

        <div class="date-range-picker-container">
          <div class="date-range-picker-label">Date Range</div>
          <date-picker
            v-model:value="date_range"
            type="date"
            range
            placeholder="Select range"
            format="MM/DD/YYYY"
            style="width: 100%;"
            :popup-class="'pricing-bonus-datepicker-popup'"
            @open="clearErrors"
            @change="clearErrors"
          ></date-picker>
          <div v-if="errors" style="color:red;font-size:12px;margin-top:10px">
            {{ errors }}
          </div>
        </div>

        <div style="margin-top:30px; display:flex; gap:40px; flex-wrap:wrap; color:gray;">

          <div>
            <div class="field-label">Order Writers (OWs)</div>
            <div v-for="ow in displayOws" :key="ow" style="display:flex; align-items:center; margin-bottom:4px; font-size:13px;">
              <span style="display:inline-block; width:60px;"
                :style="{
                  fontWeight: owStatuses[ow] === 'added' ? 'bold' : 'normal',
                  textDecoration: owStatuses[ow] === 'removed' ? 'line-through' : 'none',
                  color: owStatuses[ow] === 'removed' ? '#ccc' : 'inherit'
                }">{{ ow }}</span>
              <span style="color:#ff7214; cursor:pointer; font-size:11px;" @click="owStatuses[ow] === 'removed' ? restoreOw(ow) : removeOw(ow)">{{ owStatuses[ow] === 'removed' ? 'add back' : 'remove' }}</span>
            </div>
            <div style="display:flex; align-items:center; gap:6px; margin-top:8px;">
              <input v-model="newOw" class="field-input" style="width:80px;" placeholder="Initials" @keyup.enter="addOw" />
              <span style="color:#ff7214; cursor:pointer; font-size:11px; font-weight:500;" @click="addOw">add</span>
            </div>
          </div>

          <div>
            <div class="field-label">Account Executives (AEs)</div>
            <div v-for="ae in displayAes" :key="ae" style="display:flex; align-items:center; margin-bottom:4px; font-size:13px;">
              <span style="display:inline-block; width:60px;"
                :style="{
                  fontWeight: aeStatuses[ae] === 'added' ? 'bold' : 'normal',
                  textDecoration: aeStatuses[ae] === 'removed' ? 'line-through' : 'none',
                  color: aeStatuses[ae] === 'removed' ? '#ccc' : 'inherit'
                }">{{ ae }}</span>
              <span style="color:#ff7214; cursor:pointer; font-size:11px;" @click="aeStatuses[ae] === 'removed' ? restoreAe(ae) : removeAe(ae)">{{ aeStatuses[ae] === 'removed' ? 'add back' : 'remove' }}</span>
            </div>
            <div style="display:flex; align-items:center; gap:6px; margin-top:8px;">
              <input v-model="newAe" class="field-input" style="width:80px;" placeholder="Initials" @keyup.enter="addAe" />
              <span style="color:#ff7214; cursor:pointer; font-size:11px; font-weight:500;" @click="addAe">add</span>
            </div>
          </div>

        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn style="background:gray;color:white" @click="$emit('close')">CANCEL</v-btn>
        <v-btn style="background:#ff7214;color:white" @click="applyFilters()" :disabled="isApplyDisabled">APPLY</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import Moment from 'moment'
import DatePicker from 'vue-datepicker-next'

export default {
  name: 'PricingBonusReportFilterPopUp',
  components: { DatePicker },
  props:{
    initialFilters: {
      type: Object,
      default: () => ({})
    },
    ows: { type: Array, default: () => [] },
    aes: { type: Array, default: () => [] }
  },
  data(){
    return{
      dialog: true,
      errors: '',
      draft: {
        startDate: '',
        endDate: '',
        excludedCustomers: [],
        acceptance_rate_threshold: 0,
        conversion_rate_threshold: 0,
        bonus_pool: 0
      },
      owStatuses: {},
      aeStatuses: {},
      newOw: '',
      newAe: '',
      date_range: [],
      customers_arr: [],
      customerSearch: ''
    }
  },
  beforeMount(){
    var customers = JSON.parse(JSON.stringify( this.db.customers ) )
    var arr = []
    for(var cust_id in customers){
      var customer = customers[cust_id]
      arr.push({title: customer.customer_name + ' (' + customer.customer_number + ')', value: customer.customer_number})
    }
    arr.sort((a, b) => a.title.localeCompare(b.title, undefined, { sensitivity: 'base' }))
    this.customers_arr = arr
  },
  mounted() {
    this.draft = JSON.parse(JSON.stringify(this.initialFilters))
    const statuses = {}
    this.ows.forEach(ow => { statuses[ow] = 'existing' })
    this.owStatuses = statuses
    const aeStatuses = {}
    this.aes.forEach(ae => { aeStatuses[ae] = 'existing' })
    this.aeStatuses = aeStatuses
    const start = Moment(this.draft.startDate, 'MM/DD/YYYY', true).toDate()
    const end = Moment(this.draft.endDate, 'MM/DD/YYYY', true).toDate()
    this.date_range = [start, end]
  },
  watch: {
    date_range: {
      deep: true,
      handler() {
        this.clearErrors()
      }
    }
  },
  computed: {
    ...mapGetters(['user','db']),
    displayOws() {
      return Object.keys(this.owStatuses).sort()
    },
    displayAes() {
      return Object.keys(this.aeStatuses).sort()
    },
    isApplyDisabled() {
      return (
        !Array.isArray(this.date_range) ||
        this.date_range.length !== 2 ||
        !this.date_range[0] ||
        !this.date_range[1]
      )
    }  
  },
  methods:{
    clearErrors() {
      this.errors = ''
    },
    removeOw(ow) {
      this.owStatuses = { ...this.owStatuses, [ow]: 'removed' }
    },
    restoreOw(ow) {
      this.owStatuses = { ...this.owStatuses, [ow]: 'existing' }
    },
    removeAe(ae) {
      this.aeStatuses = { ...this.aeStatuses, [ae]: 'removed' }
    },
    restoreAe(ae) {
      this.aeStatuses = { ...this.aeStatuses, [ae]: 'existing' }
    },
    addOw() {
      const val = this.newOw.replace(/\s/g, '').toUpperCase()
      if (val && !this.owStatuses[val]) this.owStatuses = { ...this.owStatuses, [val]: 'added' }
      this.newOw = ''
    },
    addAe() {
      const val = this.newAe.replace(/\s/g, '').toUpperCase()
      if (val && !this.aeStatuses[val]) this.aeStatuses = { ...this.aeStatuses, [val]: 'added' }
      this.newAe = ''
    },
    applyFilters(){
      this.errors = ''

      if (!this.date_range || this.date_range.length !== 2 || !this.date_range[0] || !this.date_range[1]) {
        this.errors = 'Please select a start and end date.'
        return
      }

      const start = Moment(this.date_range[0])
      const end = Moment(this.date_range[1])

      if (!start.isValid() || !end.isValid()) {
        this.errors = 'Invalid date selection.'
        return
      }

      if (end.isBefore(start, 'day')) {
        this.errors = 'End date must be on or after the start date.'
        return
      }

      this.draft.startDate = start.format('MM/DD/YYYY')
      this.draft.endDate = end.format('MM/DD/YYYY')

      const startCheck = Moment(this.draft.startDate, 'MM/DD/YYYY', true)
      const endCheck = Moment(this.draft.endDate, 'MM/DD/YYYY', true)

      if (!startCheck.isValid() || !endCheck.isValid()) {
        this.errors = 'Dates must be in MM/DD/YYYY format.'
        return
      }

      const a = Number(this.draft.acceptance_rate_threshold)
      const c = Number(this.draft.conversion_rate_threshold)
      const b = Number(this.draft.bonus_pool)

      if (!Number.isFinite(a) || a < 0 || a > 100) {
        this.errors = 'Acceptance threshold must be a number between 0 and 100.'
        return
      }

      if (!Number.isFinite(c) || c < 0 || c > 100) {
        this.errors = 'Conversion threshold must be a number between 0 and 100.'
        return
      }

      if (!Number.isFinite(b) || b < 0) {
        this.errors = 'Bonus pool must be a number greater than or equal to 0.'
        return
      }

      this.draft.acceptance_rate_threshold = a
      this.draft.conversion_rate_threshold = c
      this.draft.bonus_pool = b
      this.draft.ows = Object.entries(this.owStatuses).filter(([,s]) => s !== 'removed').map(([k]) => k)
      this.draft.aes = Object.entries(this.aeStatuses).filter(([,s]) => s !== 'removed').map(([k]) => k)

      this.$emit('apply', this.draft)
    }
  }
}
</script>

<style>
  .date-range-picker-container{
/*    height: 400px;*/
  }

  .date-range-picker-label{
    color: gray;
    font-size: 12px;
    background: white;
    top: -8px;
    left: 15px;
    z-index: 1;
    width: 168px;
    padding-left: 2px;
  }

  .pricing-bonus-datepicker-popup {
    z-index: 999999 !important;
  }

  .field-input{
    color:black;
    border: 1px solid gray;
    border-radius: 3px;
    padding:2px;
  }
</style>


